module.exports = function getResource(label, vars = []) {
    const resources = {
        noShippingAddressRequired: 'Cette commande ne requiert aucun paiement ou adresse de livraison. Veuillez vérifier vos renseignements avant de passer votre commande.',
        noPaymentRequired: 'Cette commande ne requiert aucun paiement. Veuillez vérifier vos renseignements avant de passer votre commande.',
        pleaseReviewOrder: `Veuillez vérifier les informations de votre commande avant ${vars[0]}`,
        termsConditions: 'Modalités',
        andText: ' et ',
        privacyPolicy: 'Politique de confidentialité',
        pleaseReviewOrderInfoText: 'Veuillez vérifier les informations relatives à votre commande avant de passer votre commande.',
        byPlacingOrderCaText: 'En passant votre commande, vous acceptez de vous soumettre aux ',
        termsOfPurchase: 'Conditions d’achat',
        termsOfUse: 'Conditions d’utilisation',
        iAgreeToSephora: 'I Agree to Sephora’s ',
        termsOfService: 'Terms of Service ',
        andConditionsOfUse: 'Conditions of Use, have read the ',
        noticeOfFinancialIncentive: 'Notice of Financial Incentive.',
        iAgreeToAutoReplenish: 'I Agree to the Auto-Replenish ',
        termsAndConditions: 'Terms & Conditions ',
        forTheSubscription: 'for the subscription and authorize us to charge your default payment method or another payment method on file. Your subscription continues until canceled. You can cancel at any time via the Auto-Replenish page in Your Account.'
    };
    return resources[label];
};
